// All needed imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { TravelParticularComponent } from './travel-particular-component/travel-particular.component';

@NgModule({
  // Declarate the needed components
  declarations: [
    TravelParticularComponent
  ],
  // Import modules which will be used in this module
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule
  ],
  // Indicate the modules which will be used in other modules
  exports: [
    TravelParticularComponent
  ]
})
export class Form3Module { }
